/* eslint-disable import/prefer-default-export */
import { programmeSlice } from '@Store/slices/programme';

export const { setFilterState, clearFilterState } = programmeSlice.actions;
